import { entitiesTabs } from '@discover/features/entities/components/EntitiesTabs'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

const EntitiesSearchSchema = z.object({
  type: z.string().optional().catch(undefined),
  entity: z.string().optional().catch(undefined),
  tab: z.enum(entitiesTabs).optional().catch(undefined),
})

export type EntitiesSearch = z.infer<typeof EntitiesSearchSchema>

export const Route = createFileRoute('/_authenticated/$workspaceId/entities/')({
  validateSearch: (raw) => EntitiesSearchSchema.parse(raw),
})
